import React from 'react';
import CustomButton from '../../components/CustomButton/index';

import iconEmpty from './imgs/empty.svg';

interface IEmptyCompProps {
    dataType: string;
    jump: (a: string) => void;
    titleSimilar?: string;
}
export default function EmptyComp(props: IEmptyCompProps) {
    const {dataType, jump, titleSimilar} = props;
    if (dataType === 'noNumCustom') {
        return (<div className="empty">
            <img src={iconEmpty} className="icon-empty"></img>
            <p className="title">{titleSimilar}未公布官方电话</p>
            <p className="tip">
                互联网上的号码<span className="red">存在风险</span>，请您注意分辨，避免上当受骗。
            </p>
            <CustomButton
                className="empty-btn"
                type="default"
                onClick={() => jump('mark')}
            >
                12321投诉
            </CustomButton>
            <CustomButton
                className="empty-btn"
                type="default"
                onClick={() => jump('noNumFeedback')}
            >
                信息报错
            </CustomButton>
        </div>);
    }
    return (<div className="empty">
        <img src={iconEmpty} className="icon-empty"></img>
        <p className="title">暂无号码</p>
        <p className="tip">这个号码好像没有在我们这里认证哦</p>
        <CustomButton className="empty-btn" type="default" onClick={() => jump('home')}>前往首页</CustomButton>
    </div>);
}